export default __webpack_public_path__ + "static/media/unknown.b46164e5.svg";